export const formatAmount = (amount) => {
  if (amount == null) return ""; // Handle null or undefined
  const num = parseFloat(amount);
  return isNaN(num) ? "" : num.toString();
};
